const gsapController = async function () {
    const HomeIntro = document.querySelector('.home-intro') !== null;
    const ScrollingSection = document.querySelector('.scrolling-section') !== null;
    const HeadingScrollTop = document.querySelector('.heading-scroll-top') !== null;
    const VideoPopup = document.querySelector('.video-popup') !== null;
    const SwiperScroll = document.querySelector('.swiper-scroll') !== null;

    if (ScrollingSection || HeadingScrollTop || VideoPopup || ( SwiperScroll && window.innerWidth >= 768 ) ) {
        let gsap = await (await import('gsap')).default;
        let ScrollTrigger = await (await import('gsap/ScrollTrigger')).default;
        let ScrollToPlugin = await (await import('gsap/ScrollToPlugin')).default;

        gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

        if (HeadingScrollTop) {
            let HeadingScrollTop = await (await import('./gsap/heading-scroll-top')).default; 
            HeadingScrollTop(gsap);
        }

        if (VideoPopup) {
            let VideoPopup = await (await import('./video-popup')).default; 
            VideoPopup();
        }

        if (SwiperScroll) {
            let SwiperScroll = await (await import('./gsap/swiper-scroll')).default; 
            SwiperScroll(gsap); 
        }

        // if (ScrollingSection) {
        //     let ScrollingSection = await (await import('./gsap/scrolling-section')).default;
        //     ScrollingSection(gsap);
        // }

        // setTimeout(() => {
        //     gsap.to('#vue-space', { autoAlpha: 1, duration: 0.5 });
        // }, 500)
        setTimeout(() => {
            document.getElementById('vue-space').classList.add('!opacity-100');
        }, 500);
    } else {
        // let gsap = await (await import('gsap')).default;

        // setTimeout(() => {
        //     gsap.to('#vue-space', { autoAlpha: 1, duration: 0.5 });
        // }, 500)

        setTimeout(() => {
            document.getElementById('vue-space').classList.add('!opacity-100');
        }, 500);
    } 

    if (HomeIntro) {
        if ( window.innerWidth >= 768 ) {
            let gsap = await (await import('gsap')).default;
            let ScrollTrigger = await (await import('gsap/ScrollTrigger')).default;
            let ScrollToPlugin = await (await import('gsap/ScrollToPlugin')).default;
    
            gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)
    
            if (HomeIntro) {
                let HomeIntro = await (await import('./gsap/home-intro')).default;
                HomeIntro(gsap);
            }
    
            setTimeout(() => {
                gsap.to('#vue-space', { autoAlpha: 1, duration: 0.5 });
            }, 500)

        } else {
            setTimeout(() => {
                document.querySelector('header').classList.add('!opacity-100');
            }, 500);
        }
    }
}

export const init = gsapController;